// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3W71d","selected":"Chip_selected__3nZAw"};